export default __webpack_public_path__ + "static/media/talent_main-section-logo-microsoft-Dev-IT.35e2633a.svg";